__turbopack_context__.v({
  "arrowBtn": "medical-module__eNPIHG__arrowBtn",
  "audioAgentName": "medical-module__eNPIHG__audioAgentName",
  "audioAgentStatus": "medical-module__eNPIHG__audioAgentStatus",
  "audioAvatar": "medical-module__eNPIHG__audioAvatar",
  "audioLabel": "medical-module__eNPIHG__audioLabel",
  "audioPlayBtn": "medical-module__eNPIHG__audioPlayBtn",
  "audioPlayIcon": "medical-module__eNPIHG__audioPlayIcon",
  "audioStatusDot": "medical-module__eNPIHG__audioStatusDot",
  "audioStatusDotActive": "medical-module__eNPIHG__audioStatusDotActive",
  "audioWaveBar": "medical-module__eNPIHG__audioWaveBar",
  "audioWaveBarActive": "medical-module__eNPIHG__audioWaveBarActive",
  "audioWaveform": "medical-module__eNPIHG__audioWaveform",
  "audioWidget": "medical-module__eNPIHG__audioWidget",
  "audioWidgetHeader": "medical-module__eNPIHG__audioWidgetHeader",
  "ctaBtn": "medical-module__eNPIHG__ctaBtn",
  "ctaImage": "medical-module__eNPIHG__ctaImage",
  "ctaInner": "medical-module__eNPIHG__ctaInner",
  "ctaOverlay": "medical-module__eNPIHG__ctaOverlay",
  "ctaSection": "medical-module__eNPIHG__ctaSection",
  "ctaSubtitle": "medical-module__eNPIHG__ctaSubtitle",
  "ctaTitle": "medical-module__eNPIHG__ctaTitle",
  "fcIllusArea": "medical-module__eNPIHG__fcIllusArea",
  "fcPulse": "medical-module__eNPIHG__fcPulse",
  "fcSubtitle": "medical-module__eNPIHG__fcSubtitle",
  "fcTextArea": "medical-module__eNPIHG__fcTextArea",
  "fcTitle": "medical-module__eNPIHG__fcTitle",
  "fcWave": "medical-module__eNPIHG__fcWave",
  "featureCard": "medical-module__eNPIHG__featureCard",
  "featuresGrid": "medical-module__eNPIHG__featuresGrid",
  "featuresInner": "medical-module__eNPIHG__featuresInner",
  "featuresSection": "medical-module__eNPIHG__featuresSection",
  "hero": "medical-module__eNPIHG__hero",
  "heroBtnPrimary": "medical-module__eNPIHG__heroBtnPrimary",
  "heroBtnSecondary": "medical-module__eNPIHG__heroBtnSecondary",
  "heroBtns": "medical-module__eNPIHG__heroBtns",
  "heroContent": "medical-module__eNPIHG__heroContent",
  "heroImage": "medical-module__eNPIHG__heroImage",
  "heroLayout": "medical-module__eNPIHG__heroLayout",
  "heroOverlay": "medical-module__eNPIHG__heroOverlay",
  "heroSubtitle": "medical-module__eNPIHG__heroSubtitle",
  "heroTag": "medical-module__eNPIHG__heroTag",
  "heroTitle": "medical-module__eNPIHG__heroTitle",
  "howItWorksHeader": "medical-module__eNPIHG__howItWorksHeader",
  "howItWorksSection": "medical-module__eNPIHG__howItWorksSection",
  "howSubtitle": "medical-module__eNPIHG__howSubtitle",
  "howTitle": "medical-module__eNPIHG__howTitle",
  "howTitleItalic": "medical-module__eNPIHG__howTitleItalic",
  "illusAgent": "medical-module__eNPIHG__illusAgent",
  "illusApptCard": "medical-module__eNPIHG__illusApptCard",
  "illusApptConfirm": "medical-module__eNPIHG__illusApptConfirm",
  "illusApptRow": "medical-module__eNPIHG__illusApptRow",
  "illusApptTitle": "medical-module__eNPIHG__illusApptTitle",
  "illusCallBadge": "medical-module__eNPIHG__illusCallBadge",
  "illusCallDot": "medical-module__eNPIHG__illusCallDot",
  "illusCallNumber": "medical-module__eNPIHG__illusCallNumber",
  "illusCallWrap": "medical-module__eNPIHG__illusCallWrap",
  "illusDoc": "medical-module__eNPIHG__illusDoc",
  "illusDocBack1": "medical-module__eNPIHG__illusDocBack1",
  "illusDocBack2": "medical-module__eNPIHG__illusDocBack2",
  "illusDocFront": "medical-module__eNPIHG__illusDocFront",
  "illusDocIcon": "medical-module__eNPIHG__illusDocIcon",
  "illusInsBadge": "medical-module__eNPIHG__illusInsBadge",
  "illusInsCard": "medical-module__eNPIHG__illusInsCard",
  "illusInsRow": "medical-module__eNPIHG__illusInsRow",
  "illusInsTitle": "medical-module__eNPIHG__illusInsTitle",
  "illusLangBubble": "medical-module__eNPIHG__illusLangBubble",
  "illusLangTag": "medical-module__eNPIHG__illusLangTag",
  "illusLangText": "medical-module__eNPIHG__illusLangText",
  "illusLangWrap": "medical-module__eNPIHG__illusLangWrap",
  "illusLive": "medical-module__eNPIHG__illusLive",
  "illusLiveBadge": "medical-module__eNPIHG__illusLiveBadge",
  "illusLiveDot": "medical-module__eNPIHG__illusLiveDot",
  "illusLiveList": "medical-module__eNPIHG__illusLiveList",
  "illusPanel": "medical-module__eNPIHG__illusPanel",
  "illusPanelLabel": "medical-module__eNPIHG__illusPanelLabel",
  "illusPanelOn": "medical-module__eNPIHG__illusPanelOn",
  "illusPanelRow": "medical-module__eNPIHG__illusPanelRow",
  "illusPanelValue": "medical-module__eNPIHG__illusPanelValue",
  "illusPhone": "medical-module__eNPIHG__illusPhone",
  "illusPhoneBadge": "medical-module__eNPIHG__illusPhoneBadge",
  "illusPhoneLabel": "medical-module__eNPIHG__illusPhoneLabel",
  "illusPhoneNum": "medical-module__eNPIHG__illusPhoneNum",
  "illusRxBadge": "medical-module__eNPIHG__illusRxBadge",
  "illusRxCard": "medical-module__eNPIHG__illusRxCard",
  "illusRxReady": "medical-module__eNPIHG__illusRxReady",
  "illusRxRow": "medical-module__eNPIHG__illusRxRow",
  "illusRxTitle": "medical-module__eNPIHG__illusRxTitle",
  "illusStack": "medical-module__eNPIHG__illusStack",
  "illusVerifyBadge": "medical-module__eNPIHG__illusVerifyBadge",
  "illusVerifyCard": "medical-module__eNPIHG__illusVerifyCard",
  "illusVerifyRow": "medical-module__eNPIHG__illusVerifyRow",
  "illusVerifyTitle": "medical-module__eNPIHG__illusVerifyTitle",
  "illusWaveBar": "medical-module__eNPIHG__illusWaveBar",
  "illusWaveBars": "medical-module__eNPIHG__illusWaveBars",
  "livePulse": "medical-module__eNPIHG__livePulse",
  "page": "medical-module__eNPIHG__page",
  "sectionHeader": "medical-module__eNPIHG__sectionHeader",
  "sectionLabel": "medical-module__eNPIHG__sectionLabel",
  "slideCard": "medical-module__eNPIHG__slideCard",
  "slideCard1": "medical-module__eNPIHG__slideCard1",
  "slideCard2": "medical-module__eNPIHG__slideCard2",
  "slideCard3": "medical-module__eNPIHG__slideCard3",
  "slideCard4": "medical-module__eNPIHG__slideCard4",
  "slideDesc": "medical-module__eNPIHG__slideDesc",
  "slideIllus": "medical-module__eNPIHG__slideIllus",
  "slideNum": "medical-module__eNPIHG__slideNum",
  "slideText": "medical-module__eNPIHG__slideText",
  "slideTitle": "medical-module__eNPIHG__slideTitle",
  "sliderArrows": "medical-module__eNPIHG__sliderArrows",
  "sliderViewport": "medical-module__eNPIHG__sliderViewport",
});
